import styled, { css } from 'styled-components';
import {} from './index.js';
import { getMargins, getTypographyStyles, SEM_TYPOGRAPHY_FORMS_EXTENSION, SEM_TYPOGRAPHY_FORMS_INPUT, SYS_SIZE_FIXED_600, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150, SYS_BORDER_RADIUS_SM, SYS_SIZE_FIXED_1200, SEM_TYPOGRAPHY_FORMS_CAPTION, SYS_BORDER_WIDTH_100, SEM_TYPOGRAPHY_FORMS_LABEL_SMALL } from '@oneaudi/unified-web-alpha-common';
import { FormMessage } from '../form-message/index.js';
const textExtensionWidth = SYS_SIZE_FIXED_1200;
const iconButtonWidth = `24px`;
const buttonIconContainerGap = SYS_SPACE_FIXED_100;
const buttonIconPaddingRight = SYS_SPACE_FIXED_150;
const getSafeSpace = (hasIconButton, hasExtension, hasCancelButton) => {
    const hasExtras = hasIconButton || hasExtension || hasCancelButton;
    const parts = [];
    if (hasExtras) {
        parts.push(buttonIconContainerGap);
    }
    if (hasExtension) {
        parts.push(textExtensionWidth, buttonIconContainerGap);
    }
    if (hasIconButton) {
        parts.push(iconButtonWidth, buttonIconContainerGap);
    }
    if (hasCancelButton) {
        parts.push(iconButtonWidth);
    }
    parts.push(buttonIconPaddingRight);
    return `calc(${parts.join(' + ')})`;
};
export const StyledTextInput = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  display: flex;
  flex-direction: column;
`;
export const StyledLabel = styled.label `
  display: flex;
  align-items: baseline;
  padding-bottom: ${SYS_SPACE_FIXED_100};
  gap: ${SYS_SPACE_FIXED_100};
  color: ${(props) => props.$disabled
    ? props.theme.sem.color.forms.foreground.field.label.disabled
    : props.theme.sem.color.forms.foreground.field.label.default};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL_SMALL)}
  // TODO: missing token
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color;
`;
export const StyledAppendix = styled.span `
  color: ${(props) => props.$disabled
    ? props.theme.sem.color.forms.foreground.field.appendix.disabled
    : props.theme.sem.color.forms.foreground.field.appendix.default};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_CAPTION)}
`;
export const StyledUpperGroup = styled.div `
  ${(props) => props.leadingExtension &&
    css `
      display: flex;
      align-items: center;
    `}
  position: relative;
  width: 100%;
  border-radius: ${SYS_BORDER_RADIUS_SM};
  box-sizing: border-box;
  min-height: ${SYS_SIZE_FIXED_1200};
  // TODO: token missing
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: box-shadow, color, background;

  ${(props) => {
    const { $disabled, readOnly, invalid, isLoading, theme: { sem } } = props;
    const baseStroke = $disabled
        ? sem.color.forms.surface.field.stroke.disabled
        : invalid
            ? sem.color.forms.surface.field.stroke.error
            : readOnly
                ? sem.color.forms.surface.field.stroke.readOnly
                : sem.color.forms.surface.field.stroke.default;
    return css `
      box-shadow: inset 0 0 0 ${SYS_BORDER_WIDTH_100} ${baseStroke};

      ${!readOnly &&
        !$disabled &&
        css `
        background: ${props.theme.sem.color.forms.surface.field.fill.default};

        &:has(${StyledInput}:hover),
        &:has(${StyledButton}:hover) {
          box-shadow: inset 0 0 0 ${SYS_BORDER_WIDTH_100}
            ${invalid
            ? sem.color.forms.surface.field.stroke.error
            : sem.color.forms.surface.field.stroke.interactive};
          background: ${props.theme.sem.color.forms.surface.field.fill
            .interactive};
        }

        &:has(${StyledInput}:active),
        &:has(${StyledInput}:focus),
        &:has(${StyledInput}:focus-visible),
        &:focus-within {
          box-shadow: inset 0 0 0 ${SYS_BORDER_WIDTH_100}
            ${invalid
            ? sem.color.forms.surface.field.stroke.error
            : sem.color.forms.surface.field.stroke.focus};
          outline: auto;
          outline: 2px solid -webkit-focus-ring-color;
          background: ${props.theme.sem.color.forms.surface.field.fill.focus};
        }

        ${isLoading &&
            css `
          box-shadow: inset 0 0 0 ${SYS_BORDER_WIDTH_100}
            ${invalid
                ? sem.color.forms.surface.field.stroke.error
                : sem.color.forms.surface.field.stroke.focus};
          background: ${props.theme.sem.color.forms.surface.field.fill.focus};
        `}
      `}

      ${readOnly &&
        !$disabled &&
        css `
        background: ${sem.color.forms.surface.field.fill.readOnly};
      `}

      ${$disabled &&
        css `
        background: ${sem.color.forms.surface.field.fill.disabled};
      `}
    `;
}}
`;
export const StyledInput = styled.input `
  gap: ${SYS_SPACE_FIXED_100};
  color: ${(props) => props.disabled
    ? props.theme.sem.color.forms.foreground.field.input.disabled
    : props.theme.sem.color.forms.foreground.field.input.default};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_INPUT)}
  background-color: transparent;
  border: 0;
  width: 100%;
  min-height: ${SYS_SIZE_FIXED_1200};
  padding: ${(props) => `${SYS_SPACE_FIXED_150} ${getSafeSpace(!!props.hasIconButton, !!props.hasExtension, !!props.hasCancelButton)} ${SYS_SPACE_FIXED_150} ${props.leadingExtension ? SYS_SPACE_FIXED_100 : SYS_SPACE_FIXED_150}`};
  box-sizing: border-box;
  // TODO: missing token
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color;
  outline: none;

  &[type='number'] {
    -moz-appearance: textfield;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:not(:placeholder-shown),
  &:focus,
  &:active:not(:disabled) {
    + ${StyledLabel} {
      pointer-events: all;
    }
  }

  &:disabled {
    cursor: not-allowed;
  }

  &::placeholder {
    color: ${(props) => props.disabled
    ? props.theme.sem.color.forms.foreground.field.placeholder.disabled
    : props.theme.sem.color.forms.foreground.field.placeholder.default};
  }

  /* Fixes white background-color that appeared in the TextInput when the auto-complete feature was used in Chrome. */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    transition:
      background-color 0s,
      color 0s;
    transition-delay: 99999s;
  }
`;
export const StyledButtonIconContainer = styled.div `
  position: absolute;
  right: ${SYS_SPACE_FIXED_150};
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  gap: ${SYS_SPACE_FIXED_100};
  align-items: center;
  justify-content: flex-end;
  pointer-events: none;
`;
export const StyledExtension = styled.span `
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_EXTENSION)}
  // TODO: missing token
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color;
  color: ${(props) => props.$disabled
    ? props.theme.sem.color.forms.foreground.field.extension.disabled
    : props.theme.sem.color.forms.foreground.field.extension.default};
  pointer-events: none;
  text-align: center;
`;
export const StyledButton = styled.button `
  pointer-events: auto;
  background: transparent;
  border: none;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  padding: 0;
  height: ${SYS_SIZE_FIXED_600};
  width: ${SYS_SIZE_FIXED_600};
  color: ${(props) => props.disabled
    ? props.theme.sem.color.forms.foreground.field.icon.disabled
    : props.theme.sem.color.forms.foreground.field.icon.default};
`;
export const StyledFormMessage = styled(FormMessage) `
  padding-top: ${SYS_SPACE_FIXED_100};
`;
export const StyledLeadingExtension = styled.span `
  color: ${(props) => props.$disabled
    ? props.theme.sem.color.forms.foreground.field.extension.disabled
    : props.theme.sem.color.forms.foreground.field.extension.default};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_EXTENSION)}
  padding: ${SYS_SPACE_FIXED_150} 0 ${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_150};
  min-height: ${SYS_SIZE_FIXED_1200};
  display: flex;
  box-sizing: border-box;
  align-items: center;
  flex: 1 0 auto;
`;
//# sourceMappingURL=index.styles.js.map